module.exports = __webpack_public_path__ + "img/partnership.95f5d6f2.svg";